module.exports = __webpack_public_path__ + "media/vectors/term-bg-8-e9820a86.jpg";